module.exports = __webpack_public_path__ + "img/image-ru.c47555a1.png";